import { CSSProperties } from 'react';

const SHORTHAND_MAPPINGS: Record<string, string[]> = {
  margin: ['marginTop', 'marginRight', 'marginBottom', 'marginLeft'],
  padding: ['paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft'],
  inset: ['top', 'right', 'bottom', 'left'],
  borderWidth: [
    'borderTopWidth',
    'borderRightWidth',
    'borderBottomWidth',
    'borderLeftWidth'
  ],
  borderStyle: [
    'borderTopStyle',
    'borderRightStyle',
    'borderBottomStyle',
    'borderLeftStyle'
  ],
  borderColor: [
    'borderTopColor',
    'borderRightColor',
    'borderBottomColor',
    'borderLeftColor'
  ],
  gap: ['rowGap', 'columnGap'],
  flex: ['flexGrow', 'flexShrink', 'flexBasis'],
  border: ['borderWidth', 'borderStyle', 'borderColor'],
  outline: ['outlineWidth', 'outlineStyle', 'outlineColor']
};

/* eslint-disable no-magic-numbers */
export const expandCssShorthand = (styles: CSSProperties): CSSProperties => {
  const expandedStyles: Record<string, any> = {};

  Object.entries(styles).forEach(([key, value]) => {
    if (typeof value !== 'string' && typeof value !== 'number') {
      expandedStyles[key] = value;

      return;
    }

    const parts = typeof value === 'string' ? value.split(/\s+/) : [value];

    if (SHORTHAND_MAPPINGS[key]) {
      const mappings = SHORTHAND_MAPPINGS[key];
      let expandedValues: (string | number)[];

      switch (parts.length) {
        case 1:
          expandedValues = Array(4).fill(parts[0]);
          break;
        case 2:
          expandedValues = [parts[0], parts[1], parts[0], parts[1]];
          break;
        case 3:
          expandedValues = [parts[0], parts[1], parts[2], parts[1]];
          break;
        case 4:
          expandedValues = parts;
          break;
        default:
          expandedValues = Array(4).fill(parts[0]); // Fallback
      }

      mappings.forEach((prop, index) => {
        expandedStyles[prop] = expandedValues[index];
      });
    } else {
      expandedStyles[key] = value;
    }
  });

  return expandedStyles as CSSProperties;
};
